import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const AppWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.NeutralColorDarkPure};
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
  `}
`;

export const AppFrame = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1200px;
    padding: ${theme.SpacingSizeXxxs};
  `}
`;

export const HeaderWrapper = styled.header`
  ${({ theme }) => css`
    margin-top: ${theme.SpacingSizeXxl};
    display: flex;
    justify-content: space-between;
  `}
`;

export const SectionWrapper = styled.section`
  ${({ theme }) => css`
    max-width: 600px;
  `}
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.SpacingSizeXxl};
  `}
`;

export const LinksWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.SpacingSizeXxxs};
    display: flex;
    justify-content: space-between;
  `}
`;

export const LinkWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.SpacingSizeQuarck};
    min-width: 150px;
  `}
`;

export const ListsWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.SpacingSizeXxxs};
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  `}
`;


export const FooterWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.SpacingSizeXxl};
    display: flex;
    align-items: center;
  `}
`;